import React, { useId, useEffect, useState } from "react";
import { ChildContainer, Container } from "../../../../components/Container/Containers";
import styles from "./VFUserViewer.module.css";
import { Search } from "../../../../components/search/search";
import NewVFUser from "../add/NewVFUser.container";
import { Loader } from "../../../../components/loader/Loader";
import { formatSecondsToDate } from "../../../../utils/dateTime";
import IMAGES from "../../../../assets/images/images";
import { Field, Form, Formik ,ErrorMessage} from "formik";
import * as Yup from "yup";
// import { Alert } from "../../../../components/alert/alerts";
import InfiniteScroll from "react-infinite-scroll-component";
import { FUNCTIONAL_ROLES_CONSTANTS, USER_TYPE } from "../../../../utils/constants/userConstants";
import { EmptyContainer } from "../../../dashboard/graphs/component/component";
import { FormFieldLabel as Label ,FormErrorLabel as ErrorLabel} from "../../../../components/label/Labels";
import DynamicTable from "../../../../components/dynamicTable/dynamicTable";
import { computeWeightedWidths, formatDate, useNotificationId, usePopupPosition } from "../../../../utils/arrayUtils";
import SectionGuard from "../../../../hoc/guards/SectionGuard";
import CAN from "../../../../casl/can";
import { Action, Resource } from "../../../../casl/constants";
import SecondaryTooltip from "../../../../components/secondaryToolTip/secondaryToolTip";
import ConfirmationPopup from "../../../../components/confirmationPopup/ConfirmationPopup";
import { AppliedFilter, Filter } from "../../../../components/filter/filter";
import Table from "../../../../components/table/Table";
import { COLUMN_KEYS, FILTER_KEYS, SORT_FIELDS, SORT_ORDER, vfSortOptions, vFUserscolumnConfig } from "../../../../utils/constants/userManagementConstant";
import DetailsTooltip from "../../../../components/detailsTooltip/detailsTooltip";
import ListSorter from "../../../../components/listSorter/ListSorter";


const CheckBox = ({ name, value, label }) => {
  const id = useId();
  return (
    <div className={styles.radioField}>
      <Field
        id={id}
        className={styles.radioInput}
        type="checkbox"
        name={name}
        value={value}
      />
      <label htmlFor={id} className={styles.radioLabel}>
        {label}
      </label>
    </div>
  );
};

const RadioField = ({ name, value, label }) => {
  const id = useId();
  return (
    <div className={styles.radioField}>
      <Field
        id={id}
        className={styles.radioInput}
        type="radio"
        name={name}
        value={value}
      />
      <label htmlFor={id} className={styles.radioLabel}>
        {label}
      </label>
    </div>
  );
};

const SearchList = ({getSearchKeyValue, filterData,onKeyDownHandler,setSearchKeyValue,getUser}) => {
  const inputSearchStyle = `${styles.searchList} `;

  const filterByQuickSearch=(value)=>{
   setSearchKeyValue(value)
   getUser(USER_TYPE.INTERNAL,"",value.trim(),null)
  }
  return (
    <div className={styles.searchBar}>
      <Search 
        placeholder={"Search"}
        style={inputSearchStyle}
        getSearchKeyValue={getSearchKeyValue}
        onButtonClick={filterByQuickSearch}
      />
    </div>
  );
};

const ExpandableArea = ({ children }) => {
  const [expanded, setExpanded] = useState(false);

  if (!expanded) {
    return (
      <div className={styles.expanded}>
        <button
          className={styles.transparentBtn}
          onClick={() => setExpanded(true)}
        >
          <span>View More</span>
          <img src={IMAGES.arrowdown} width={24} height={24} alt="down arrow" />
        </button>
      </div>
    );
  }

  return (
    <div className={styles.expanded}>
      <div>
        <button
          className={styles.transparentBtn}
          onClick={() => setExpanded(false)}
        >
          <span>View Less</span>
          <img src={IMAGES.arrowup} width={24} height={24} alt="up arrow" />
        </button>
      </div>

      {children}
    </div>
  );
};

const VfHeader = ({ getSearchKeyValue, filterData, searchKeyValue,onKeyDownHandler,data,functionalRoles,setSearchKeyValue,getUser={getUser},count,sortConfig, setSortConfig }) => {

  return (
    <div className={styles.headContainer}>
      <div className={styles.vfuser}>Vodafone Users <span className={styles.count}> (Total: {count})</span>
        {/* <SearchList
          getSearchKeyValue={getSearchKeyValue}
          searchKeyValue={searchKeyValue}
          filterData={filterData}
          onKeyDownHandler={onKeyDownHandler}
          setSearchKeyValue={setSearchKeyValue}
          getUser={getUser}
        /> */}
      </div>
      <div className={styles.addNew}>
        <ListSorter options={vfSortOptions} sortConfig={sortConfig} onChange={setSortConfig}/>
        <NewVFUser data={data} functionalRoles={functionalRoles} source="new"/>
      </div>
    </div>
  )
}

  const Switch = ({ isChecked, onClick,reason }) => {

    const logs = reason?.userStatusMetadata?.userInactivityLogs ?? [];
    const lastLog = logs.at(-1);
    const statusText = reason?.status === "active" ? "Active" : "Inactive";
    const tooltipContent = logs.length > 0 ? (
      <DetailsTooltip
        data={{
          Status: lastLog?.status === "active" ? "Active" : "Inactive",
          [lastLog?.status === "active" ? "Activated By" : "Deactivated By"]: lastLog?.modifiedBy?.name,
          [lastLog?.status === "active" ? "Activated On" : "Deactivated On"]: formatDate(lastLog?.modifiedAt),
          Reason: lastLog?.reason,
        }}
      />
    ) : (
      statusText
    );
     
  return (
    <SecondaryTooltip text={tooltipContent} customCss={"broadcastCss"} backgroundStyle={"backgroundStyle"} positions={['bottom', 'right','top']}>
      <label className={styles.switch}>     
        <input type="checkbox" checked={isChecked} onClick={onClick}  className={styles.CheckBoxswitch}/>
        <span className={styles.slider}></span>
      </label>
      </SecondaryTooltip>
  );
};

const UserList = ({ data, functionalRolesData,updateUserPermissions, openAlertPopup,SubmitActiveInactive,getUser,handleUserName,handleUserRole,isLoading,VFuserNames,UserName,UserRole,notificationdata,readNotification,sortConfig,setSortConfig,...props}) => {
  let [isAlert, setIsAlert] = useState(false);
  let [isEditPermission, setIsEditPermission]=useState(false);
  let [showLoader, setShowLoader]=useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [loadingUserId, setLoadingUserId] = useState(null);

  const handleSort = (field) => {
    setSortConfig((prev) => ({field,order : prev.field === field && prev.order === SORT_ORDER.ASC ? SORT_ORDER.DESC : SORT_ORDER.ASC,}));
  };

  const notificationId = useNotificationId();
  useEffect(() => {
    if (notificationId) {
      const payload = { read: true };
      readNotification(payload,notificationId)
    }
  }, [notificationId]);

  const [message, setMessage] = useState({
    message: "",
    image: IMAGES.success
  });

  const [filterState, setFilterState] = useState({
    isNameFilterPopup: false,
    selectedNameOptions: props?.columnFilters?.vfUserName || [],
    isRoleFilterPopup: false,
    selectedRoleOptions: props?.columnFilters?.role || []
  });

  const validationSchema = Yup.object().shape({
    functionalRoles:Yup.string().required("Kindly choose one role.")
    //functionalRoles: Yup.array().min(1,"Kindly choose at least one role.").max(1,"Please select only one role.")
  });
  let initialValues = {
    functionalRoles: data?.functionalRoles && data?.functionalRoles.length>0?data?.functionalRoles.toString():"",
  }

  const editPermission =()=>{
    setIsEditPermission(!isEditPermission);
  }

  const onSubmit = (isChecked,id,reason,email,setShowPopup) => { 
    setIsSubmit(true); 
    setLoadingUserId(id); 
    const payload = {
      status: isChecked  ? "inactive" : "active",
      reason:reason
    };
    SubmitActiveInactive(payload,id).then((result) => {
      if (result.status) {
        openAlertPopup({
         message: `${email} has been ${isChecked ? "deactivated" : "activated"} successfully!`,
          image: IMAGES.success,
        });
        setIsSubmit(false);
        setLoadingUserId(null);
        setShowPopup(false);
        const selectedNames = UserName.map((item) => item.value).join(",");
        const selectedRoles = UserRole.map((item) => item.value).join(",");
        const sort = `${sortConfig.field}:${sortConfig.order}`;
        getUser(USER_TYPE.INTERNAL,"","","",selectedNames,selectedRoles,sort);
      } else {
        let error_msg = result?.error?.message ?? "An error occurred while processing your request. Please try again later.";
        openAlertPopup({
          message: error_msg,
          image: IMAGES.error,
        //  isFormOpen:true
        });
       setIsSubmit(false);
       setLoadingUserId(null);
       setShowPopup(false);
      }
    })
    .catch((error) => {
      openAlertPopup({
        message: "An error occurred while processing your request. Please try again later.",
        image: IMAGES.error,
      //  isFormOpen:true
      });
    setIsSubmit(false);
    setLoadingUserId(null);
    setShowPopup(false);
    });
 };

 const [showPopup, setShowPopup] = useState(false);
 const [userToConfirm, setUserToConfirm] = useState(null);
 
 const handleSwitchClick = (user) => {
   if (CAN(Action.TOGGLE_USER_STATUS, Resource.RIGHTS) && user?.email !== props?.myRights?.email) {
     setShowPopup(true);
     setUserToConfirm(user);
   }
 };

 const handleConfirm = (reason) => {
   onSubmit(userToConfirm?.status === 'active', userToConfirm?.id,reason,userToConfirm?.email,setShowPopup);
 };
 
 const handleCancel = () => {
   setShowPopup(false);
 };

 const handleNameFilterApply = (selectedOptions) => {
  setFilterState(prevState => ({...prevState,selectedNameOptions: selectedOptions}));
  props.setColumnFilters(FILTER_KEYS.VFUSER,COLUMN_KEYS.VF_USER_NAME,selectedOptions);
  handleUserName(selectedOptions)
};

 const handleRoleFilterApply = (options) => {
  setFilterState(prevState => ({...prevState,selectedRoleOptions: options}));
  props.setColumnFilters(FILTER_KEYS.VFUSER,COLUMN_KEYS.ROLE,options);
  handleUserRole(options)
};

const handleNameFilterReset = () => {
  setFilterState(prevState => ({ ...prevState, selectedNameOptions: [],}));
  props.setColumnFilters(FILTER_KEYS.VFUSER,COLUMN_KEYS.VF_USER_NAME,[]);
  handleUserName([]);
};

const handleRoleFilterReset = () => {
  setFilterState(prevState => ({  ...prevState, selectedRoleOptions: [],}));
  props.setColumnFilters(FILTER_KEYS.VFUSER,COLUMN_KEYS.ROLE,[]);
  handleUserRole([])
};

const resetappliedFilter = () =>{
  props?.resetColumnFilters(FILTER_KEYS.VFUSER)
  handleNameFilterReset();
  handleRoleFilterReset();
  handleUserName([]);
  handleUserRole([])
}
const { position, columnRef, iconRef, calculatePosition } = usePopupPosition(300);
  const headers =[
    <div  ref={columnRef} className={styles.organisationName} key="userName"><div className={`${styles.orgname} ${styles.orgnwidth}`}>User Name
      </div>
      <div ref={iconRef} className={styles.popup} onClick={calculatePosition}>
      <img className={`${styles.filter} ${filterState.selectedNameOptions?.length > 0? styles.activeFilter: ""}`} src={IMAGES.filtericon} onClick={() => setFilterState(prevState => ({ ...prevState, isNameFilterPopup: true }))} alt="Filter" />
      {filterState.isNameFilterPopup && (<Filter position={position} isOpen={filterState.isNameFilterPopup} options={VFuserNames?.map(values => ({ value: values?.uid, label: values?.displayName }))} onApply={handleNameFilterApply} onRequestClose={() => setFilterState(prevState => ({ ...prevState, isNameFilterPopup: false }))} label={"User Name"} initialSelectedOptions={filterState.selectedNameOptions} onReset={handleNameFilterReset} />)}
      </div>
    </div>,
    <div className={styles.organisationName} key="emailAddress"><div className={styles.orgname}>Email Address</div></div>,
    <div className={styles.organisationName} key="role"><div className={styles.orgname}>Role</div>
      <div className={styles.popup}>
      <img className={`${styles.filter} ${filterState.selectedRoleOptions?.length > 0? styles.activeFilter: ""}`} src={IMAGES.filtericon} onClick={() => setFilterState(prevState => ({ ...prevState, isRoleFilterPopup: true }))} alt="Filter" />
      {filterState.isRoleFilterPopup && (<Filter position={'left'} isOpen={filterState.isRoleFilterPopup} options={functionalRolesData?.map(values => ({ value: values?.id, label: values?.name }))} onApply={handleRoleFilterApply} onRequestClose={() => setFilterState(prevState => ({ ...prevState, isRoleFilterPopup: false }))} label={"Role"} initialSelectedOptions={filterState.selectedRoleOptions} onReset={handleRoleFilterReset} />)}
      </div>
    </div>,
    <div className={styles.organisationName} key="createdOn"><div className={styles.orgname}>Created On</div></div>,
    <div className={styles.organisationName} key="recentLoginTime"><div className={styles.orgname}>Recent Activity Time</div></div>,
    <div className={styles.organisationName} key="lastUpdatedOn"><div className={styles.orgname}>Last Updated On</div>
    {/* <img className={`${styles.sorting} ${sortOrder==='desc'?styles.desc:styles.asc}`} src={IMAGES.sorticon} onClick={toggleSortOrder} alt="sort"/> */} 
    </div>,
    <div className={styles.organisationName} key="status"><div className={styles.orgname}>Status</div></div>,
    <div className={styles.organisationName} key="editAccess"><div className={styles.orgname}>Edit Access</div></div>,
    ]

    const mappedData = data?.map((user) => {
      const match = notificationdata?.find(row => row.detailsId === user.id);
      const highlightClass = match ? styles.highlightedRow : '';
      return {
        "userName": <span className={`${styles.customDataContent} ${styles.posrelative}`}><span className={`${highlightClass}`}></span><SecondaryTooltip text={match?.message?match.message:user?.displayName} positions={['bottom', 'right']}>{user?.displayName}</SecondaryTooltip></span>,
        "emailAddress": <span className={`${styles.customDataContent}`}><SecondaryTooltip copy={true} text={user?.email} positions={['bottom', 'right']}>{user?.email}</SecondaryTooltip></span>,  
        "role": <span className={`${styles.customDataContent}`}><SecondaryTooltip text={FUNCTIONAL_ROLES_CONSTANTS[user?.functionalRoles[0]]?.label} positions={['bottom', 'right']}>{FUNCTIONAL_ROLES_CONSTANTS[user?.functionalRoles[0]]?.label}</SecondaryTooltip></span>,
        "createdOn": <span className={`${styles.customDataContent}`}><SecondaryTooltip text={formatDate(user?.createdAt)} positions={['bottom', 'right']}>{formatDate(user?.createdAt)}</SecondaryTooltip></span>,
        "recentLoginTime": <span className={`${styles.customDataContent}`}><SecondaryTooltip text={user?.currentLoginTime?formatDate(user?.currentLoginTime):"Not Available"} positions={['bottom', 'right']}>{user?.currentLoginTime?formatDate(user?.currentLoginTime):"Not Available"}</SecondaryTooltip></span>,
        "lastUpdatedOn": <span className={`${styles.customDataContent}`}><SecondaryTooltip text={user?.modifiedAt?formatDate(user?.modifiedAt):"Not Available"} positions={['bottom', 'right']}>{user?.modifiedAt?formatDate(user?.modifiedAt):"Not Available"}</SecondaryTooltip></span>,
        "status": <span className={`${styles.customDataContent}  ${styles.editwrapper}`}>
          <div className={ `${styles.sidedetail}`}>
            <p className={styles.active}>
              {isSubmit && loadingUserId === user?.id ?
                <Loader loaderStyle={styles.loaderStyle} /> :
                <span className={styles.spanSwitch}>
                  <Switch
                    isChecked={user?.status === "active"}
                    reason={user}
                    onClick={() => handleSwitchClick(user)}
                  />
                </span>
              }
            </p> 
          </div>
        </span>,  
        'editAccess':<div className={styles.editwrapper}>
          <NewVFUser
            UserName={UserName}
            UserRole={UserRole}
            sortConfig={sortConfig}
            source="edit"
            data ={user}
            userList={data}
            functionalRolesData={functionalRolesData}
            updateUserPermissions={updateUserPermissions}
            openAlertPopup= {openAlertPopup}
          />
        </div>     
      };});

  return (
    <div className={styles.VfUserListContainers}>
     {(filterState.selectedNameOptions.length > 0 || filterState.selectedRoleOptions.length>0) && (<AppliedFilter selectedFilterOptions={filterState.selectedNameOptions} selectedInvoicingPartyOptions={filterState.selectedRoleOptions} onReset={resetappliedFilter}setSelectedFilterOptions={setFilterState} handleFilterApply={handleNameFilterApply} handleInvoicingFilterApply={handleRoleFilterApply} firstFilterLabel={"User Name"} secondFilterLabel={"Role"}/>)}
     <div className={styles.wrapper}>
        <Table headers={headers} data={mappedData} height={`${mappedData?.length<8 &&(filterState?.isNameFilterPopup||filterState?.isRoleFilterPopup)?"480px":"auto"}`} width="100%" 
          columnConfig={computeWeightedWidths(vFUserscolumnConfig)}  isWidth={true}
          nodata={!isLoading && mappedData?.length===0?"No Data.": <Loader/>}
        />
    </div>
       {showPopup && (
    <ConfirmationPopup
      header={"Status Update"}
      isSubmitActive={isSubmit}
      status={userToConfirm.status ==='active'? 'Inactive': "Active"}
      data={<span>Do you wish to change status to <span className={styles.popupmsg}>{userToConfirm?.status ==='active'? 'Inactive': "Active"}</span> for <span className={styles.popupmsg}>{userToConfirm?.displayName}</span>?</span>}
      onConfirm={handleConfirm}
      onCancel={handleCancel}
    />
  )}
      {/* <div className={styles.VfUserList}>
        <span className={styles.spanlabel}>Name</span>
        <p>{data.displayName}</p>
      </div>
      <div className={styles.VfUserList}>
        <span className={styles.spanlabel}>Email Address</span>
        <p>{data.email}</p>
      </div> */}
      {/* <div className={styles.VfUserList}>
        <span className={styles.spanlabel}>Mobile Number</span>
        <p>{data.phoneNumber}</p>
      </div> */}
      {/* <div className={styles.VfUserList}>
        <span className={styles.spanlabel}>Onboarded On</span>
        <p>{formatSecondsToDate(data.createdAt)}</p>
      </div>
      <div className={styles.VfUserList}>
        <span className={styles.spanlabel}>Status </span>
        <p>{""}Inactive <span className={styles.spanSwitch}><Switch isChecked={data.status === "active" ? true : false} /></span>Active</p>
      </div> */}
      {/* <ExpandableArea>
        <div style={{ width: "100%" }}>
          <div>
            <Formik
              initialValues={initialValues}
              enableReinitialize={true}
              validationSchema={validationSchema}
              validateOnChange
              onSubmit={async (values, { resetForm }) => {
                  //values.userType=data.userType;
                  let obj = JSON.parse(JSON.stringify(values));
                  obj.functionalRoles=[values.functionalRoles];
                  obj.userType=data.userType;
                  setShowLoader(true);
                  updateUserPermissions(obj,data.uid).then((result) => {
                    if (result.status) {
                      setIsEditPermission(!isEditPermission);
                      // setMessage({
                      //   message: "User permissions updated successfully.",
                      //   image: IMAGES.success
                      // });
                      // setIsAlert(true);
                      openAlertPopup({
                        message: "User permissions updated successfully!",
                        image: IMAGES.success
                      });
                      setShowLoader(false);
                    } else {
                      let error_msg = result?.error;
                      setIsEditPermission(!isEditPermission);
                      // setMessage({
                      //   message: error_msg,
                      //   image: IMAGES.error
                      // });
                      // setIsAlert(true);
                      openAlertPopup({
                        message: error_msg,
                        image: IMAGES.error
                      });
                      setShowLoader(false);
                    }
                  })
                    .catch((error) => {
                      setIsEditPermission(!isEditPermission);
                      // setMessage({
                      //   message: "Something went wrong.",
                      //   image: IMAGES.error
                      // });
                      // setIsAlert(true);
                      openAlertPopup({
                        message: "Something went wrong.",
                        image: IMAGES.error
                      });
                      setShowLoader(false);
                    });

                

              }}
            >
              {({ isValid, dirty ,submitForm}) => (
                <Form className={styles.form}>
                   <div className={styles.sectionContainer}>
                      <div  className={styles.sectionTitle}>Modules Assigned</div>
                      {
                        showLoader?
                        <div className={styles.loaderContainer}><Loader style={styles.loaderContainer}/></div>:
                        isEditPermission?
                          <div><img src={IMAGES.save} className={styles.Icon} onClick={submitForm} /></div>
                        :
                          <div><img src={IMAGES.editIcon} className={styles.Icon}  onClick={editPermission} /></div>
                      }
                  </div>
                  <ul
                    style={{
                      listStyle: "none",
                      paddingInlineStart: 0,
                      display: "grid",
                      gap: 16,
                      gridTemplateColumns: "repeat(2, 1fr)",
                    }}
                  >
                    {functionalRolesData.map((role) => (
                      <li
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <fieldset disabled={!isEditPermission} >                        
                          <RadioField name="functionalRoles" value={role.id} label={role.name} />
                        </fieldset>
                      </li>
                    ))}
                    <ErrorMessage name ="functionalRoles">
                    {(msg)=><ErrorLabel text={msg} />}
                  </ErrorMessage>
                  </ul>
                  <div>
                  </div>
                 
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </ExpandableArea> */}
    </div>
  );
};

const VFUSerViewer = (props) => {
  const { userList, isLoading,functionalRoles,notificationdata,VFuserNames} = props;
  let [searchKeyValue, setSearchKeyValue] = useState("");
  const [UserName, setUserName] = useState(props?.columnFilters?.vfUserName || []);
  const [UserRole, setUserRole] = useState(props?.columnFilters?.role || []);
  const [sortConfig, setSortConfig] = useState({field: SORT_FIELDS.USER_NAME,order: SORT_ORDER.ASC});

  const handleUserName = (data) =>{
    setUserName(data);
  }
  
  const handleUserRole =(data)=>{
    setUserRole(data)
  }
  const getSearchKeyValue = (e) => {
    setSearchKeyValue(e.target.value);
  };

  const filterData = (key, value) => {
    let searchKey = searchKeyValue.trim();
    let type=USER_TYPE.INTERNAL;
    let custID="";
    let next=null;
    const selectedNames = UserName.map((item) => item.value).join(",");
    const selectedRoles = UserRole.map((item) => item.value).join(",");
    const sort = `${sortConfig.field}:${sortConfig.order}`;
    props.getUser(type,custID,searchKey,next,selectedNames,selectedRoles,sort);
  };
  useEffect(()=>{
    filterData();
    window.scrollTo(0,0);
  },[UserName,UserRole,sortConfig])

  const onKeyDownHandler = (e) => {   // filter data on enter event
    if (e.key === "Enter"){
      filterData();  
    }
  };

  useEffect(() => {
    let searchKey = "";
    let type=USER_TYPE.INTERNAL;
    let custID="";
    let next=null;
    props.getAllVFusersList();
    const selectedNames = UserName.map((item) => item.value).join(",");
    const selectedRoles = UserRole.map((item) => item.value).join(",");
    const sort = `${sortConfig.field}:${sortConfig.order}`;
    props.getUser(type,custID,searchKey,next,selectedNames,selectedRoles,sort);
    props.getPredefinedRoles("internal");
  //   if (notificationdata?.length > 0) {
  //     notificationdata.forEach(notification => {
  //       const payload = {
  //         read: true,
  //       };
  //       props.ReadNotification(payload, notification.id);
  //       props.getModuleNotification(null);
  //       props.NotificationOptions()
  //     });
  // }
  
    return () => {
      props.resetUserList();
    };
  }, []);
  console.log("sortConfig---",sortConfig)
  return (
    <React.Fragment>
      <div className={styles.infodetails}><img className={styles.circleinfo} src={IMAGES.infoCircle}/><span className={styles.infotext}>This section displays a list of all Vodafone/Internal users who are onboarded to the IPXplore portal, along with their assigned roles and current status. It also provides the functionality to quickly edit user access and roles by clicking the <span className={styles.boldtext}>'Edit Access'</span> link.</span></div>
      <div className={styles.containerwrapper}>
        <div className={styles.note}>Note: The table below is grouped by the <span className={styles.boldtext}>Role</span> column in alphabetical order. Within each role group, users are displayed based on the selected <span className={styles.boldtext}>Sort by</span> option.</div>
        <VfHeader
          getSearchKeyValue={getSearchKeyValue}
          searchKeyValue={searchKeyValue}
          filterData={filterData}
          onKeyDownHandler={onKeyDownHandler}
          data={userList}
          functionalRoles={functionalRoles}
          setSearchKeyValue={setSearchKeyValue}
          getUser={props.getUser}
          count={props?.count ?? 0}
          sortConfig={sortConfig}
          setSortConfig={setSortConfig}
        />
      {isLoading && userList.length != 0 && <Loader />}
        <InfiniteScroll
          dataLength={userList?.length} //This is important field to render the next data
          next={() => {
            const selectedNames = UserName.map((item) => item.value).join(",");
            const selectedRoles = UserRole.map((item) => item.value).join(",");
            const sort = `${sortConfig.field}:${sortConfig.order}`;
            return props.getUser(USER_TYPE.INTERNAL, "", searchKeyValue.trim(), props.next,selectedNames,selectedRoles,sort);
          }}
          hasMore={props.next}
          loader={
              <Loader />
          }
        >
          {/* {userList?.map((userData) => ( */}
            <UserList
             UserName={UserName}
             UserRole={UserRole}
             setSortConfig={setSortConfig}
             sortConfig={sortConfig}
             handleUserRole = {handleUserRole}
             handleUserName = {handleUserName}
              isLoading={isLoading}
              data={userList}
              functionalRolesData={functionalRoles}
              VFuserNames={VFuserNames}
              updateUserPermissions={props.updateUserPermissions}
              SubmitActiveInactive={props.SubmitActiveInactive}
              openAlertPopup={props.openAlertPopup}
              getUser={props.getUser}
              notificationdata={notificationdata}
              readNotification={props.ReadNotification}
              columnFilters={props?.columnFilters}
              setColumnFilters={props.setColumnFilters}
              resetColumnFilters={props.resetColumnFilters}
              myRights={props.myRights}
            />
          {/* ))} */}
        </InfiniteScroll>
      </div>
    </React.Fragment>
  );
};

export default VFUSerViewer;
